import {PropsWithChildren} from "react";
import {Box, Button, Stack, Text, View} from "@unibuddy/patron";
import {IconChevronLeft, IconChevronRight} from "@unibuddy/icons";
import {Image, ScrollView, TouchableOpacity} from "react-native";
import {boldFontStyles} from "../Styles/fontStyles";
import {SpaceValue} from "../StudentApp/SpacesProvider";
import {SelectionDirection} from "./HomeBar";

type HomeBarContentProps = {
    selectedSpace: SpaceValue;
    handleSpaceChangerToggle: (show: boolean) => void;
    handleSpaceSelection: (direction: SelectionDirection) => void;
};

const NavigationButton = ({
    children,
    onPress,
    disabled,
    ariaLabel,
}: PropsWithChildren<{
    onPress: () => void;
    disabled?: boolean;
    ariaLabel?: string;
}>) => {
    return (
        <TouchableOpacity
            onPress={onPress}
            disabled={disabled}
            accessibilityRole="button"
            accessibilityLabel={ariaLabel}
        >
            {children}
        </TouchableOpacity>
    );
};

export function HomeUniversityName({selectedSpace}: {selectedSpace: SpaceValue}) {
    return (
        <View maxW="80%" margin="auto">
            <View flexDirection="row" alignItems="center" gap="xsmall">
                <Box
                    flexShrink={0}
                    borderWidth={0.5}
                    borderColor="grey150"
                    style={{
                        borderRadius: 6,
                        overflow: "hidden",
                    }}
                >
                    <Image
                        style={{borderRadius: 6}}
                        source={{uri: selectedSpace?.logo ?? undefined, height: 34, width: 34}}
                        accessibilityLabel="University logo"
                    />
                </Box>
                <ScrollView
                    horizontal
                    showsHorizontalScrollIndicator={false}
                    contentContainerStyle={{
                        paddingTop: 4,
                        paddingBottom: 4,
                    }}
                >
                    <Text
                        style={{
                            ...boldFontStyles,
                        }}
                        color="white"
                    >
                        {selectedSpace?.name}
                    </Text>
                </ScrollView>
            </View>
        </View>
    );
}

export function HomeCommunityTitle({selectedSpace}: {selectedSpace: SpaceValue}) {
    return (
        <Box display="flex" width="100%" justifyContent="center">
            <View maxW="80%">
                <ScrollView
                    horizontal
                    showsHorizontalScrollIndicator={false}
                    contentContainerStyle={{paddingTop: 4, paddingBottom: 4}}
                >
                    <Text color="white" align="center" size="small">
                        {selectedSpace?.title}
                    </Text>
                </ScrollView>
            </View>
        </Box>
    );
}
export const HomeBarContent = ({
    selectedSpace,
    handleSpaceChangerToggle,
    handleSpaceSelection,
}: HomeBarContentProps) => {
    return (
        <Stack space="small">
            <Box display="flex" justifyContent="space-between" alignItems="center" w="100%">
                <NavigationButton
                    onPress={() => handleSpaceSelection(SelectionDirection.PREVIOUS)}
                    ariaLabel="Previous space"
                >
                    <IconChevronLeft color="white" />
                </NavigationButton>
                <HomeUniversityName selectedSpace={selectedSpace} />

                <NavigationButton
                    onPress={() => handleSpaceSelection(SelectionDirection.NEXT)}
                    ariaLabel="Next space"
                >
                    <IconChevronRight color="white" />
                </NavigationButton>
            </Box>
            <HomeCommunityTitle selectedSpace={selectedSpace} />
            <View width="100%" alignItems="center">
                <Button
                    round
                    ghost
                    size="sm"
                    style={{
                        borderColor: "white",
                        height: 30,
                    }}
                    onClick={() => handleSpaceChangerToggle(false)}
                >
                    <Text size="xxsmall" color="white">
                        Hide details
                    </Text>
                </Button>
            </View>
        </Stack>
    );
};
